module.exports = __webpack_public_path__ + "images/af9223fb472993bab2756cfee376fc15-launch.png";